const en = {
  minimumValue: 'Minimum value',
  search: 'Search...',
  goToCheckout: 'Go to checkout',
  pleaseWait: 'Please wait...',
  orderCreatedSuccessfully: 'Order created successfully!',
  checkout: 'Checkout',
  addressDetails: 'Address Details',
  phoneNumber: "Phone Number",
  orderDetails: "Order Details",
  paymentMethod: "Payment Method",
  cash: "Cash",
  subtotal: "Subtotal",
  deliveryCharge: "Delivery Charge",
  total: "Total",
  verificationCodeWasNotCorrect: "Verification code was not correct",
  confirmationCode: "Confirmation Code",
  enterThe4DigitCodeThatWeSentViaSMS: "Enter the 4-digit code that we sent via SMS",
  close: "Close",
  enterAddress: "Enter Address",
  enterYourDesiredDeliveryAddress: "Enter your desired delivery address",
  youNeedADeliveryAddressToProceed: "You need a delivery address to proceed",
  setAddress: "Set address",
  allowLocationPermissionToBrowserFromMobileSettingsForThisFunctionality: "Allow location permission to browser from mobile settings for this functionality",
  geolocationIsNotSupportedInThisBrowser: "Geo location is not supported in this browser",
  searchAddress: "Search Address",
  deliveryAddress: "Delivery address",
  weAreNotAbleToCompleteYourOrderProcess: "We are not able to complete your order process",
  pleaseTryAgainWhenServiceIsSupported: "Please try again when service is supported.",
  thankYouForYourOrder: "Thank you for your order",
  invoiceDate: "Invoice Date",
  accepted: "Accepted",
  cancelled: "Cancelled",
  requested: "Requested",
  delivering: "Delivering",
  paymentInProgress: "Payment in progress",
  waitingForConfirmation: "Waiting for confirmation",
  orderId: "Order Id",
  restaurant: "Restaurant",
  address: "Address",
  orderAgain: "Order again",
  openHours: "Open Hours",
  placeYourOrder: "Place your order",
  errors: {
    empty_delivery_address: "Delivery address cannot be empty",
    empty_phone_number: "Phone Number cannot be empty",
    invalid_phone_number: "Invalid phone number"
  },
  table: "Table",
  refresh: "Refresh",
  inOrderToCheckAvailabilityOfFunctionalityAndProceedWithMenu: "In order to check availability of functionality and proceed with menu",
  weWereNotAbleToCompleteYourOrderProcess: "We were not able to complete your order process",
  clientMustBeInsideDefinedZones: "Client must be inside defined zones",
  pleaseTryAgainWhenVisitingOurBusiness: "Please try again when visiting our business",
  theProvidedQrIsInvalid: "The provided QR is invalid",
  leaveAReview: 'Leave a review'
};

export default en;
